<div class="lib-survey-slider__container">
  <div class="lib-survey-slider__labels">
    <h4 class="lib-survey-slider__min-label">{{ question.minLabel }}</h4>
    <h4 class="lib-survey-slider__max-label">{{ question.maxLabel }}</h4>
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
